import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
  DialogPdf,
  ButtonHLPure,
  HeaderHLPure,
  InputFileHLPure,
} from "../../pures";
import { b64toBlob } from "./../../../validators";
import "./queries-and-validations-validation-signed-documents.css";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'

const QueriesAndValidationsValidationSignedDocumentView = (props) => {
  // Set traslation hook
  const { t } = useTranslation();

  // Set mobile hooks
  const [currentSystem, setCurrentSystem] = useState("");
  const [blobUrl, setBlobUrl] = useState("");
  const [selectedFileBase64, setSelectedFileBase64] = useState('')

  const pdf = useMemo(() => {
    const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : ''
    return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
  }, [selectedFileBase64])

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.filePdfBase64) {
      const blob = b64toBlob(props.filePdfBase64, "application/pdf");
      setBlobUrl(blob);
      if (props.filePdfBase64 !== '') {
        setSelectedFileBase64(props.filePdfBase64)
      }
    }
  }, [props.filePdfBase64]);

  let infodevice = currentSystem.toLowerCase();
  let screenSizeWidth = window.screen.width;
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  isMobile = isMobile || screenSizeWidth <= 650;
  props.dataItem.contractActive = true
  // Container custom styles
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    padding: "20px",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            <HeaderHLPure title={t("validationSignedDocumentsView.validationsAndQueries")} />
          </Grid>


          <Grid container>
            {/* === [START] Main Fragment to show "Files form" or show "Result validation" === */}
            {!props.showValidationResults ? (
              <Fragment>
                {/* Input file to PDF */}
                <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                  <InputFileHLPure
                    labelActive
                    labelInputFile={t("validationSignedDocumentsView.inputfilePdfDescription")}
                    messageBtn={t("validationSignedDocumentsView.inputfilePdfText")}
                    acceptFile={"application/pdf"}
                    selectedFile={props.filePdf}
                    selectedFileName={props.targetFiles ? props.targetFiles.name : ""}
                    handleFile={e => props.onSaveFile(e, "document_pdf")}
                    handleDeleteFile={e => props.onDeleteFile("document_pdf")}
                    errorFile={props.errorMessageList[0].showError}
                    flex={true}
                  />
                </Grid>

                {/* Render PDF document if was provided */}
                {props.showPdfFounded ? (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    {isMobile ? (
                      <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-mobile-button-showPdf">
                        <DialogPdf blobUrl={blobUrl} />
                      </div>
                    ) : (
                      pdf
                      // <PdfReader className="pdfReader" file={props.filePdfBase64} isFile
                      //   src={
                      //     props.filePdf && props.filePdfBase64 !== ""
                      //       ? `data:application/pdf;base64,${props.filePdfBase64}#toolbar=0`
                      //       : null
                      //   } />

                    )}
                  </Grid>
                ) : null}

                {/* Leyend of PSC services founded by PDF document validation */}
                {props.showAsn1CMFounded || props.showAsn1STFounded ? (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-documents-description-p">
                      {t(
                        "validationSignedDocumentsView.theDocumentToValidInludeServices"
                      )}{" "}
                      <span className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-documents-description-span">
                        {props.serviceListPsc}
                      </span>
                      .{" "}
                      {t(
                        "validationSignedDocumentsView.pleaseUploadTheFiles"
                      )}
                    </p>
                  </Grid>
                ) : null}

                {/* Input file to ASN1 for CM */}
                {props.showAsn1CMFounded ? (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    <InputFileHLPure
                      labelActive
                      labelInputFile={t("validationSignedDocumentsView.inputfileAsn1CMDescription")}
                      messageBtn={t("validationSignedDocumentsView.inputfileAsn1CMText")}
                      acceptFile={".asn1"}
                      selectedFile={props.fileAsn1CM}
                      selectedFileName={props.fileAsn1CM ? props.fileAsn1CM.name : ""}
                      handleFile={e => props.onSaveFile(e, "cm_asn1")}
                      handleDeleteFile={e => props.onDeleteFile("cm_asn1")}
                      errorFile={props.errorMessageList[1].showError}
                      flex={true}
                    />
                  </Grid>
                ) : null}

                {/* Input file to ASN1 for ST */}
                {props.showAsn1STFounded ? (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    <InputFileHLPure
                      labelActive
                      labelInputFile={t("validationSignedDocumentsView.inputfileAsn1STDescription")}
                      messageBtn={t("validationSignedDocumentsView.inputfileAsn1STText")}
                      acceptFile={".asn1"}
                      selectedFile={props.fileAsn1ST}
                      selectedFileName={props.fileAsn1ST ? props.fileAsn1ST.name : ""}
                      handleFile={e => props.onSaveFile(e, "st_asn1")}
                      handleDeleteFile={e => props.onDeleteFile("st_asn1")}
                      errorFile={props.errorMessageList[2].showError}
                      flex={true}
                    />
                  </Grid>
                ) : null}

                {/* Group buttons of "Cancel" and "validate document", or "Return" */}
                {props.filePdf ? (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-buttons-div">
                      <Link to="/queries-and-validations" className="QueriesAndValidationsValidationSignedDocumentView-link-button">
                        <ButtonHLPure
                          nameBtn={t("validationSignedDocumentsView.buttonCancel")}
                          onClickBtn={() => props.scrollWindow()}
                        />
                      </Link>
                      {props.showValidationButton ? (
                        <ButtonHLPure
                          id="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-button-margin"
                          nameBtn={t("validationSignedDocumentsView.buttonValidateDocuments")}
                          onClickBtn={() => props.onValidRequestDocuments()}
                          primary
                        />
                      ) : (
                        <ButtonHLPure
                          id="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-button-margin"
                          nameBtn={t("validationSignedDocumentsView.buttonConfirmDocuments")}
                          onClickBtn={() => props.onSearchDocumentPdf(props.targetFiles)}
                          primary
                        />
                      )}
                    </div>
                  </Grid>
                ) : (
                  <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                    <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-buttons-div">
                      <Link to="/queries-and-validations" className="QueriesAndValidationsValidationSignedDocumentView-link-button">
                        <ButtonHLPure
                          id="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-button-margin"
                          nameBtn={t("validationSignedDocumentsView.buttonReturn")}
                          onClickBtn={() => props.scrollWindow()}
                        />
                      </Link>
                    </div>
                  </Grid>
                )}
              </Fragment>
            ) : (
              <Fragment>
                {/* Description of validation confirm result */}
                <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper">
                  <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-validation-confirm-subtitle">
                    {t(
                      "validationSignedDocumentsView.resultOfValidationDocument"
                    )}
                  </p>
                  <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-validation-confirm-p">
                    {t("validationSignedDocumentsView.result")}{" "}
                    <span className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-validation-confirm-valid-span">
                      {props.validationPdfResult.messageValid}
                    </span>
                  </p>
                  <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-validation-confirm-p-bold">
                    {t(
                      "validationSignedDocumentsView.theDocumentWasSignedByAkubica"
                    )}
                  </p>
                </Grid>

                <Grid container spacing={2} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box">
                  {/* Box validation report results */}
                  <Grid item xs={12} >
                    <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf">
                      <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-img-container">
                        <img
                          alt="Documento válido"
                          width={80}
                          src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icono_documento_valido.png"
                        />
                      </div>

                      <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content">
                        <div>
                          <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                            <p>
                              {t(
                                "validationSignedDocumentsView.nameOfDocument"
                              )}
                            </p>
                            <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy filename">
                              {props.validationPdfResult.documentName}
                            </p>
                          </div>
                          <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                            <p>
                              {t("validationSignedDocumentsView.nameOfRequest")}
                            </p>
                            <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy">
                              {props.validationPdfResult.requestName}
                            </p>
                          </div>
                          <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                            <p>
                              {t(
                                "validationSignedDocumentsView.descriptionOfDocument"
                              )}
                            </p>
                            <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy">
                              {props.validationPdfResult.requestDescription}
                            </p>
                          </div>
                        </div>

                        <div>
                          <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                            <p>{t("validationSignedDocumentsView.endDate")}</p>
                            <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy">
                              {props.validationPdfResult.requestEndDate}
                            </p>
                          </div>
                          <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                            <p>
                              {t("validationSignedDocumentsView.signatureType")}
                            </p>
                            <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy">
                              {props.validationPdfResult.requestSignatureType}
                            </p>
                          </div>
                          {props.validationPdfResult.hash ? (
                            <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-p">
                              <p>{t("validationSignedDocumentsView.hash")}</p>
                              <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-pdf-content-italy filename">
                                {props.validationPdfResult.hash}
                              </p>
                            </div>
                          ) : null}
                        </div>

                        <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-tracking-documents">
                          <p>{t("validationSignedDocumentsView.documents.tracking")}</p>
                          <div className="icon-tracking">
                            <Link
                              to={{
                                pathname: `/document-tracking/${props.dataItem.id}`,
                                params: { dataItem: props.dataItem },
                              }}
                            >
                              <img
                                src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_tracking_document.png"
                                width={20}
                                alt="tracking-icon"
                              ></img>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>

                  {/* Box Conservation Message */}
                  <Grid item xs={12} md={6}>
                    <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1">
                      <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-img-container">
                        <img
                          alt="Constancia de conservación de mensajes"
                          width={40}
                          src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icono_constancia_conservacion.png"
                        />
                      </div>

                      {props.showAsn1CMFounded &&
                        props.validationAsn1CMResult.messageValid !== "" ? (
                        <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-items">
                          <p>
                            {t(
                              "validationSignedDocumentsView.conservationMessage"
                            )}
                          </p>
                          <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-p-valid">
                            {props.validationAsn1CMResult.messageValid}
                          </p>
                          <p>
                            {t("validationSignedDocumentsView.fileName")}
                          </p>
                          <p className="filename">{props.validationAsn1CMResult.documentName}</p>
                        </div>
                      ) : (
                        <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-items">
                          <p>
                            {t(
                              "validationSignedDocumentsView.conservationMessage"
                            )}
                          </p>
                          <p>
                            {t("validationSignedDocumentsView.notUsed")}
                          </p>
                        </div>
                      )}
                    </div>
                  </Grid>

                  {/* Box Stamping Time */}
                  <Grid item xs={12} md={6}>
                    <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1">
                      <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-img-container">
                        <img
                          alt="Sello de tiempo"
                          width={40}
                          src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icono_sello_tiempo.png"
                        />
                      </div>
                      {props.showAsn1STFounded &&
                        props.validationAsn1STResult.messageValid !== "" ? (
                        <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-items">
                          <p>
                            {t(
                              "validationSignedDocumentsView.stampingTime"
                            )}
                          </p>
                          <p className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-p-valid">
                            {props.validationAsn1STResult.messageValid}
                          </p>
                          <p>
                            {t("validationSignedDocumentsView.fileName")}
                          </p>
                          <p className="filename">{props.validationAsn1STResult.documentName}</p>
                        </div>
                      ) : (
                        <div className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-results-box-asn1-items">
                          <p>
                            {t(
                              "validationSignedDocumentsView.stampingTime"
                            )}
                          </p>
                          <p>
                            {t("validationSignedDocumentsView.notUsed")}
                          </p>
                        </div>
                      )}
                    </div>
                  </Grid>
                </Grid>

                {/* Groups of buttons "Close and send report" and "New report" */}
                <Grid item xs={12} className="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-div-wrapper QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-buttons-div">
                  <ButtonHLPure
                    nameBtn={t("validationSignedDocumentsView.buttonNewReport")}
                    onClickBtn={() => props.onClearToNewReport()}
                  />
                  <ButtonHLPure
                    primary
                    id="QueriesAndValidationsValidationSignedDocumentView-validationSignedDocuments-button-margin"
                    nameBtn={t("validationSignedDocumentsView.buttonCloseAndSendReport")}
                    onClickBtn={() => props.onCloseAndSendValidationReport()}
                  />
                </Grid>
              </Fragment>
            )}{" "}
            {/* === [END] Main Fragment to show "Files form" or show "Result validation" ===  */}
          </Grid>

          {/* Componet pure "Promotional footer" */}
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
          >
            <PromotionalFooterPure />
          </Grid>

          {/* Alerts of Notification Completed and Loadign */}
          <DialogSystemGLPure
            {...props}
            toggleLoadingRequesting={props.toggleLoadingRequesting}
            toggleCompletedRequesting={props.toggleCompletedRequesting}
            toggleErrorRequesting={props.toggleErrorRequesting}
          />
        </Container>
      )}
    </div>
  );
};

export { QueriesAndValidationsValidationSignedDocumentView as default };
